import * as React from 'react'

import OddsHeader from '../Odds/OddsHeader'
import PlayerInfoRow from '../Elements/PlayerInfoRowElement'
import OddsRow from '../Odds/OddsRow'
import { getFlagUrl } from '../../api/assetUrls';

import('./PlayerAndOddsStyles.scss')   


interface PlayerAndOddsPresentationProps {
  id?: string
  quickBetsState?: any
  baseUrl: string
  clientid: number
  playerids: any
  playerAbbreviationNames: any
  matchId: number
  clickedOdds: any
  betstop: boolean
  winnerDetermined: boolean
  setWinnerOdds: any
  gameWinnerOdds: any
  pointWinnerOdds: any
}

const PlayerAndOddsPresentation = ( props: PlayerAndOddsPresentationProps ) => {
  return (
    <div id={props.id} className={"oddsContainer " + toggleVisibility(props.quickBetsState)}>
      <OddsHeader />
      <div className="oddsWrapper">
        <div className="oddsContainer-playerInfoRow">
          <PlayerInfoRow  flagUrl = { getFlagUrl( props.baseUrl, props.clientid, props.playerids.home ) }
                          playerAbbreviationName = {props.playerAbbreviationNames['home']} />
        </div>
        <OddsRow  matchId = { props.matchId }
                  clickedOdds = { props.clickedOdds }
                  betstop = { props.betstop }
                  winnerDetermined={props.winnerDetermined}
                  homeOrAway = { 'home' }
                  oddsValue1 = { props.setWinnerOdds }
                  oddsValue2 = { props.gameWinnerOdds}
                  oddsValue3 = { props.pointWinnerOdds } />
      </div>
      <div className="oddsWrapper">
        <div className="oddsContainer-playerInfoRow">
          <PlayerInfoRow  flagUrl = { getFlagUrl( props.baseUrl, props.clientid, props.playerids.away ) }
                          playerAbbreviationName = {props.playerAbbreviationNames['away']} />
        </div>
        <OddsRow  matchId = { props.matchId }
                  clickedOdds = { props.clickedOdds }
                  betstop = { props.betstop }
                  winnerDetermined={props.winnerDetermined}
                  homeOrAway = { 'away' }
                  oddsValue1 = { props.setWinnerOdds }
                  oddsValue2 = { props.gameWinnerOdds}
                  oddsValue3 = { props.pointWinnerOdds } />
      </div>
    </div>
  )
}

const toggleVisibility = ( active: boolean) => {
  return active === false ? '' : 'showOddsSection';
}

export default PlayerAndOddsPresentation
